import React from "react";

export function Panel({ title, meta, right, children, className = "", testId }) {
  return (
    <section
      data-testid={testId}
      className={`panel relative ${className}`}
    >
      {(title || meta || right) && (
        <header className="flex items-center justify-between border-b border-zinc-900 px-4 py-2">
          {title && (
            <h3 className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
              {title}
            </h3>
          )}
          <div className="flex items-center gap-3">
            {meta && <div className="font-mono text-[11px] text-zinc-600">{meta}</div>}
            {right}
          </div>
        </header>
      )}
      {children}
    </section>
  );
}

export function Stat({ label, value, delta, accent = "amber", testId, sub }) {
  const color = {
    amber: "text-[#FFB000]",
    green: "text-[#00E676]",
    red: "text-[#FF3B30]",
    white: "text-white",
  }[accent];
  const up = (delta ?? 0) >= 0;
  return (
    <div className="panel p-4" data-testid={testId}>
      <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{label}</div>
      <div className={`font-mono text-3xl font-medium mt-2 ${color}`}>{value}</div>
      {delta !== undefined && (
        <div className={`font-mono text-[11px] mt-1 ${up ? "text-[#00E676]" : "text-[#FF3B30]"}`}>
          {up ? "▲" : "▼"} {Math.abs(delta).toFixed(2)}%
        </div>
      )}
      {sub && (
        <div className="font-mono text-[10px] text-zinc-600 mt-1 uppercase tracking-widest">
          {sub}
        </div>
      )}
    </div>
  );
}
